/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Dependents/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DataVaxiomRelationshipsList from 'DesignSystem/DataVaxiomRelationshipsList/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Dependents({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Relations/Sections/Dependents"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let profilePatientPersonIdValueData = fromData.useDataValue({ viewPath,
context: 'profile_patient',
path: 'person._id',
})
  return (<React.Fragment
>
<div
  data-testid="Dependents.Horizontal"
  data-view-path={viewPath}
 style={{'--pl-1-2k4G6a': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-2-2k4G6a': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pt-3-2k4G6a': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pb-4-2k4G6a': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 text="Dependents"
/>
</div>
<DataVaxiomRelationshipsList
  viewPath={`${viewPath}/DataVaxiomRelationshipsList`}
 data="profile_patient.person._id"
 to_person={profilePatientPersonIdValueData}
 role="DEPENDENT"
/>
{children}
</React.Fragment>)
}